module.exports = __webpack_public_path__ + "img/45_15.daa9a31c.png";